import { AccountBrand, SearchBrandItem } from "@/screens/analysis/types";
import BrandRow from "./BrandRow";
import ItemLoader from "@/components/common/loaders/ItemLoader";

type Props = {
  brands: SearchBrandItem[];
  loading: boolean | null;
  onSelect: (brand: SearchBrandItem) => void;
  searchQuery: string;
  selectedBrands?: SearchBrandItem[];
  addedBrands?: AccountBrand[];
};

const SearchBrandDropdown = (props: Props) => {
  return (
    <div className="flex flex-col w-full bg-white min-h-[150px] h-auto max-h-[400px] overflow-y-auto rounded-[8px] border border-border-gray">
      {props.loading === true ? (
        <div className="flex-1 w-full h-full flex items-center justify-center">
          <ItemLoader />
        </div>
      ) : props.loading === false && props.brands.length === 0 ? (
        <div className="flex-1 w-full h-full flex items-center justify-center">
          <div className="w-full px-[9px] flex flex-col justify-center items-center gap-[12px]">
            <div className="text-brand-primary-800 text-[14px] font-normal leading-none">
              No matches for "<span className="font-medium">{props.searchQuery}</span>"
            </div>

            <span className="text-brand-primary-600 text-[12px] font-normal leading-[20px]">
              Try another name or paste the brand's Facebook page URL.
            </span>
          </div>
        </div>
      ) : (
        props.brands.map((brand) => (
          <BrandRow
            key={brand.page_id}
            brand={brand}
            isSelected={
              props.selectedBrands?.some((b) => b.page_id === brand.page_id) || false
            }
            isAdded={props.addedBrands?.some((b) => b.page_id === brand.page_id) || false}
            onClick={() => {
              props.onSelect(brand);
            }}
          />
        ))
      )}
    </div>
  );
};

export default SearchBrandDropdown;
